import React from 'react';
import { DefaultWidgetWithHeader } from '../../_lib/components/Widget';
import { Widget as WidgetShape } from '../../types/api/Widget';
import { WidgetType } from '../../types/api/ElementType';
import { Icons } from '../../components/atoms/SVG';
import { isEmptyBlock } from '../../types/api/Block';
import { PersonExtendedDataBlock } from '../../_blocks/PersonExtendedData/PersonExtendedDataBlock';
import { useSonTranslation } from '../../translation/useSonTranslation';

export type PersonExtendedDataWidget = WidgetShape<[PersonExtendedDataBlock], WidgetType.personextendeddata>;

export function PersonExtendedDataWidget({ blocks, elementType, ...headerProps }: PersonExtendedDataWidget) {
  const { t } = useSonTranslation('PersonExtendedData');

  if (isEmptyBlock(blocks[0])) {
    return null;
  }

  return (
    <DefaultWidgetWithHeader
      {...headerProps}
      widgetType={elementType}
      icon={Icons.SKILLS_RIBBON}
      title={t('widgetTitle')}
    >
      <PersonExtendedDataBlock {...blocks[0]} />
    </DefaultWidgetWithHeader>
  );
}
